export enum SortField {
  Title = 1,
  PublishedAt = 8,
}
